import { JiraField } from 'api/integrations';

export const getJiraFormValues = (
  fields: JiraField[] = [],
): Record<string, any> =>
  fields.reduce((acc, field) => {
    const { integrationFieldId, metaData } = field;

    acc[integrationFieldId] = metaData?.default;

    return acc;
  }, {});
